import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { ClickableProps } from "@insite/mobius/Clickable";
import DataTable, { DataTableProps, SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import HistoryContext, { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EditPunchoutModal from "@TKCCP/Components/EditPunchoutModal";
import PunchoutModal from "@TKCCP/Components/PunchoutModal";
import loadPunchouts from "@TKCCP/Store/Data/PunchoutSecretService/Handlers/LoadPunchoutSecretHandler";
import { PunchoutDataViewContext } from "@TKCCP/Store/Data/PunchoutSecretService/PunchoutSecretServiceSelector";
import deletePunchOutSecret from "@TKCCP/Store/Pages/PunchoutSecret/Handlers/DeletePunchoutSecret";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import identity from "lodash/identity";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface State {
    deleteSecretModalIsOpen: boolean;
    leaveSecretModalIsOpen: boolean;
    punchOutSecretId: string;
    editSecretModalIsOpen: boolean;

    editCompany: string;
    editSecretId: string;
    editIsActive: boolean;
    editId: string;
}

const mapStateToProps = (state: ApplicationStateTKCCP) => {
    return {
        parameter: state.pagePunchoutSecret.getPunchoutParameter,
    };
};

const mapDispatchToProps = {
    deletePunchOutSecret,
    loadPunchouts,
    // updateSearchFields,
    // reorder,
};

type Props = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory;

export interface PunchoutSecretTableStyles {
    container?: InjectableCss;
    headerClickable?: ClickableProps;
    headerText?: TypographyProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    companyNameHeader?: DataTableHeaderProps;
    sharedSecretHeader?: DataTableHeaderProps;
    activeStatusHeader?: DataTableHeaderProps;
    actionHeader?: DataTableHeaderProps;
    companyNameCells?: DataTableCellProps;
    statusCells?: DataTableCellProps;
    sharedSecretCells?: DataTableCellProps;
    actionCells?: DataTableCellProps;
    deleteButton?: ButtonPresentationProps;
    editButton?: ButtonPresentationProps;
    dataTable?: DataTableProps;
}

export const PunchoutSecretTableStyles: PunchoutSecretTableStyles = {
    container: {
        css: css`
            overflow: auto;
            margin-top: 0;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noResultsContainer: {
        css: css`
            text-align: center;
            padding: 20px;
        `,
    },
    noResultsText: {
        variant: "h4",
    },
    headerClickable: {
        css: css`
            width: 100%;
            justify-content: space-between;
        `,
    },
    deleteButton: {
        color: "secondary",
        sizeVariant: "medium",
    },
    editButton: {
        color: "secondary",
        sizeVariant: "medium",
        css: css`
            margin-right: 15px;
        `,
    },
    companyNameCells: {
        css: css`
            width: 25%;
        `,
    },
    sharedSecretCells: {
        css: css`
            width: 45%;
            white-space: inherit;
            span {
                word-break: break-word;
            }
        `,
    },
    statusCells: {
        css: css`
            width: 15%;
        `,
    },
    dataTable: {
        css: css`
            td {
                padding: 4px 12px;
            }
        `,
        cssOverrides: {
            table: css`
                min-width: 700px;
            `,
        },
    },
};

const styles = PunchoutSecretTableStyles;

class PunchoutSecretTable extends React.Component<Props, State> {
    static contextType = PunchoutDataViewContext;
    context!: React.ContextType<typeof PunchoutDataViewContext>;

    punchoutDeleteHandler = (userId: string) => {
        this.setState({ punchOutSecretId: userId });
        this.setState({ deleteSecretModalIsOpen: true });
        // const queryString = `id=${userId}`;
        // this.props.history.push(`/myaccount/addSecret?${queryString}`);
    };
    constructor(props: Props) {
        super(props);
        this.state = {
            deleteSecretModalIsOpen: false,
            leaveSecretModalIsOpen: false,
            punchOutSecretId: "",
            editSecretModalIsOpen: false,
            editCompany: "",
            editSecretId: "",
            editIsActive: false,
            editId: "",
        };
    }
    deleteCancelHandler = () => {
        this.setState({ deleteSecretModalIsOpen: false });
    };
    deleteSubmitHandler = () => {
        this.setState({ deleteSecretModalIsOpen: false });
        if (this.state.punchOutSecretId !== "") {
            this.props.deletePunchOutSecret({
                PunchOutSecretId: this.state.punchOutSecretId,
                onSuccess: () => {
                    this.setState({ deleteSecretModalIsOpen: false });
                    this.props.loadPunchouts(this.props.parameter);
                    this.props.toaster.addToast({
                        body: siteMessage("Punchout Secret Deleted"),
                        messageType: "success",
                        timeoutLength: 9000,
                    });
                },
            });
        }
    };

    closePunchoutModalHandler = () => {
        this.setState({ editSecretModalIsOpen: false });
    };

    editPunchOutSecretClickHandler = (id: string, company: string, sharedSecret: string, active: boolean) => {
        this.setState({ editCompany: company });
        this.setState({ editId: id });
        this.setState({ editIsActive: active });
        this.setState({ editSecretId: sharedSecret });
        this.setState({ editSecretModalIsOpen: true });
    };
    render() {
        const secretDataView = this.context;
        if (secretDataView.isLoading) {
            return (
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.spinner} />
                </StyledWrapper>
            );
        }

        if (!secretDataView.value) {
            return null;
        }

        if (secretDataView.value.length === 0) {
            return (
                <StyledWrapper {...styles.noResultsContainer}>
                    <Typography as="p" {...styles.noResultsText} data-test-selector="punchoutSecretTable_noOrdersFound">
                        {translate("No Secret found")}
                    </Typography>
                </StyledWrapper>
            );
        }

        const rows = secretDataView.value.map(secret => {
            return {
                id: secret.id,
                company: secret.company,
                sharedSecret: secret.sharedSecret,
                isActive: secret.isActive,
            };
        });

        return (
            <StyledWrapper {...styles.container}>
                <DataTable {...styles.dataTable}>
                    <DataTableHead data-test-selector="puchoutSecretTable">
                        <DataTableHeader {...styles.companyNameHeader}>{translate("Company")}</DataTableHeader>
                        <DataTableHeader {...styles.sharedSecretHeader}>{translate("Shared Secret")}</DataTableHeader>
                        <DataTableHeader {...styles.activeStatusHeader}>{translate("Active")}</DataTableHeader>
                        <DataTableHeader {...styles.actionHeader}>{translate("Action")}</DataTableHeader>
                    </DataTableHead>
                    <DataTableBody data-test-selector="puchoutSecret_tableBody">
                        {rows.map(({ id, company, sharedSecret, isActive }) => (
                            <DataTableRow key={id}>
                                <DataTableCell
                                    {...styles.companyNameCells}
                                    data-test-selector="puchoutSecretTable_tableCell_companyName"
                                >
                                    {company}
                                </DataTableCell>
                                <DataTableCell
                                    {...styles.sharedSecretCells}
                                    data-test-selector="puchoutSecretTable_tableCell_sharedSecret"
                                >
                                    {sharedSecret}
                                </DataTableCell>
                                <DataTableCell {...styles.statusCells}>
                                    {isActive ? "Active" : "InActive"}
                                </DataTableCell>

                                <DataTableCell {...styles.actionCells}>
                                    <Button
                                        {...styles.editButton}
                                        onClick={() =>
                                            this.editPunchOutSecretClickHandler(id, company, sharedSecret, isActive)
                                        }
                                    >
                                        {translate("Edit")}
                                    </Button>

                                    <Button {...styles.deleteButton} onClick={() => this.punchoutDeleteHandler(id)}>
                                        {translate("Delete")}
                                    </Button>
                                </DataTableCell>
                            </DataTableRow>
                        ))}
                    </DataTableBody>
                </DataTable>
                <TwoButtonModal
                    modalIsOpen={this.state.deleteSecretModalIsOpen}
                    headlineText={translate("Delete Secret")}
                    messageText={`${translate("Are you sure you want to delete")}`}
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Delete")}
                    onCancel={this.deleteCancelHandler}
                    onSubmit={this.deleteSubmitHandler}
                    submitTestSelector="mySecretSubmitDelete"
                ></TwoButtonModal>
                <EditPunchoutModal
                    editModalIsOpen={this.state.editSecretModalIsOpen}
                    editComapny={this.state.editCompany}
                    editIsActive={this.state.editIsActive}
                    editSharedSecret={this.state.editSecretId}
                    editId={this.state.editId}
                    handleClose={this.closePunchoutModalHandler}
                />
            </StyledWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(PunchoutSecretTable))),
    definition: {
        group: "Order History",
        displayName: "PunchoutSecretTable",
    },
};
export default widgetModule;
